import { EQueryTagTypes, ISwoolBaseResponse } from "../types/api";
import {
  IBankResponseItem,
  IBankRequestParams,
  ICreateBankRequest,
} from "../types/bank.types";
import api from ".";

const bankApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBanks: build.query<IBankResponseItem[], IBankRequestParams>({
      query: (params) => {
        return {
          url: "/api/bank/filter",
          method: "GET",
          params,
        };
      },
      transformResponse: (data: ISwoolBaseResponse<IBankResponseItem[]>) => {
        return data.data;
      },
      providesTags: () => [{ type: EQueryTagTypes.BANKS_LIST, id: "LIST" }],
    }),
    addNewBank: build.mutation<IBankResponseItem, ICreateBankRequest>({
      query: (body) => {
        return {
          url: "/api/bank",
          method: "POST",
          body,
        };
      },
      transformResponse: (data: ISwoolBaseResponse<IBankResponseItem>) => {
        return data.data;
      },
      invalidatesTags: () => [{ type: EQueryTagTypes.BANKS_LIST, id: "LIST" }],
    }),
  }),
});

export const { useLazyGetBanksQuery, useAddNewBankMutation } = bankApi;
